import { CContainer } from "@coreui/react";
import React, { useEffect, useState } from "react";
import "../../assets/css/resume.css";
import ReactTest from "../../assets/images/Certificates/ReactTest.png";
import JavaScript from "../../assets/images/Certificates/JavaScriptTest.jpg";
import ChatGPT from "../../assets/images/Certificates/ChatGPT.png";
import JavaScript2 from "../../assets/images/Certificates/JavaScript_Assessment.png";
import NodeJS from "../../assets/images/Certificates/NodeJS_Assessment.png";
import HTMLCSS from "../../assets/images/Certificates/HTML_CSS_Assessment.png";
import Footer from "../footer/footer";
import Navbars from "../navbar/navbar";
import { Helmet } from "react-helmet";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import ReactGA from "react-ga4";

export default function Certificates() {
  const [show, setShow] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    image: "",
  });

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const handleClose = (x) => {
    if (x !== "") {
      window.open(x);
    }
  };

  const datas = [
    {
      image: ChatGPT,
      title: "AI Prompt Engineering",
      link: "",
      description:
        "Certified in AI Prompt Engineering from Skill Nation, demonstrating proficiency in creating and optimizing AI prompts for enhanced performance.",
    },
    {
      image: ReactTest,
      title: "React Assessment",
      link: "https://www.foundit.in/skillyst/view-report/164889-5565732020-mohanraj-m-frontend-reactjs-test-1",
      description:
        "Certified React developer with expertise demonstrated through successful completion of React test on FoundIt platform.",
    },
    {
      image: JavaScript2,
      title: "JavaScript Assessment",
      link: "https://www.foundit.in/skillyst/view-report/490474-e11aaf36c3-mohanraj-m-fullstack-sern-test",
      description:
        "Certified in JavaScript through successful completion of the Foundit platform test, showcasing proficiency in web development and programming.",
    },
    {
      image: JavaScript,
      title: "JavaScript Assessment",
      link: "https://cutshort.io/certificate/66591",
      description:
        "Certified in JavaScript through successful completion of the Cutshort platform test, showcasing proficiency in web development and programming.",
    },
    {
      image: NodeJS,
      title: "NodeJS Assessment",
      link: "https://www.foundit.in/skillyst/view-report/490495-0478ec845f-mohanraj-m-backend-nodejs-test",
      description:
        "Certified NodeJS developer with proficiency demonstrated through successful completion of the NodeJS test on the FoundIt platform.",
    },
    {
      image: HTMLCSS,
      title: "HTML/CSS Assessment",
      link: "https://www.foundit.in/skillyst/view-report/490443-11137c234d-mohanraj-m-html-css-skill",
      description:
        "Certified in HTML/CSS from FoundIt platform, showcasing proficiency in web development and design.",
    },
  ];

  const handleShow = (item) => {
    setModalData({
      title: item.title,
      image: item.image,
    });
    setShow(true);
  };

  return (
    <div className="cert">
      <Helmet>
        <title>Mohanraj - Certifications</title>
        <meta
          name="description"
          content="Certified mastery in cutting-edge technologies, showcasing top-tier proficiency in fullstack development."
        />
      </Helmet>
      <Navbars />
      <div className="resumers certificates">
        <CContainer>
          <br />
          <br />
          <br />
          <br />
          <Row>
            {datas.map((item, index) => (
              <Col
                key={index}
                style={{ marginBottom: 40, marginTop: 10 }}
                lg={4}
                md={6}
                sm={12}
                xs={12}
              >
                <Card
                  style={{
                    width: "85%",
                    boxShadow:
                      "#1d76bc85 0px 4px 8px 0px, rgba(21, 0, 0, 0.15) 0px 6px 20px 0px",
                    margin: "auto",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={item.image}
                    className="cardImage"
                  />
                  <Card.Body className="cardBody">
                    <Card.Title>{item.title}</Card.Title>
                    <Card.Text className="description">
                      {item.description}
                    </Card.Text>
                    <div className="cardFoot">
                      <Button className="view" onClick={() => handleShow(item)}>
                        View
                      </Button>
                      <Button
                        className="link"
                        onClick={() => handleClose(item.link)}
                      >
                        Link
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <br />
        </CContainer>

        <div className="foot">
          <Footer />
        </div>
      </div>

      <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{modalData.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={modalData.image}
            alt="modelImg"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
